export const useDocsLink = (docsLink?: string) => {
    if (docsLink && docsLink.includes('squaredup.com')) {
        const { pathname } = new URL(docsLink);
        return pathname;
    }
};
